/** @format */
import { post } from '@root/utils/httpWrap';

function transformParam(p: any) {
  return {
    ...p
  };
}
/**
 * 消息中心-消息列表
 */
export const serchSysMsg = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/msg/serchSysMsg', transformParam(params));
};
/**
 * 消息中心-消息已读
 */
export const messageIsRead = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/msg/isRead', transformParam(params));
};
/**
 * 消息中心-消息删除
 */
export const messageIsDel = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/msg/isDel', transformParam(params));
};
